import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import AdminNavbar from "../Components/AdminNavbar";

export default function ChangeEmailPassword() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  // Fetch email on load
  const fetchEmail = async () => {
    try {
      const res = await axios.get("https://dropshopi.com/api/get-admin-user.php");
      if (res.data.status === "success") {

        console.log("res", res);
        setFormData((prev) => ({
          ...prev,
          email: res.data.data.email,
        }));
      }
    } catch (err) {
      console.error("Error fetching admin email", err);
    }
  };

  useEffect(() => {
    fetchEmail();
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password || !formData.confirmPassword) {
      return Swal.fire("Error", "Please fill all fields.", "error");
    }

    if (formData.password !== formData.confirmPassword) {
      return Swal.fire("Error", "Passwords do not match.", "error");
    }

    setLoading(true);

    try {
      const res = await axios.post("https://dropshopi.com/api/update-admin-user.php", {
        email: formData.email,
        password: formData.password,
      });

      if (res.data.status === "success") {
        Swal.fire("Success", res.data.message, "success");
        setFormData((prev) => ({
          ...prev,
          password: "",
          confirmPassword: "",
        }));
      } else {
        Swal.fire("Error", res.data.message || "Update failed.", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong.", "error");
    }

    setLoading(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="container py-5 text-white"
      style={{ background: "#121212", minHeight: "100vh" }}
    >
      <AdminNavbar />
      <h2 className="mb-4 text-warning">Update Admin Credentials</h2>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                className="form-control bg-dark text-white border-secondary"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input
                type="password"
                name="password"
                className="form-control bg-dark text-white border-secondary"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                className="form-control bg-dark text-white border-secondary"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-warning w-100"
              disabled={loading}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Update"
              )}
            </button>
          </form>
        </div>
      </div>
    </motion.div>
  );
}
